// extracted by mini-css-extract-plugin
module.exports = {"w1g5igiq":"w1g5igiq","ba6j99p":"ba6j99p","bophso7":"bophso7","hi4kqwz":"hi4kqwz","gp2r524":"gp2r524"};